import { GetInvestmentDetailsRes } from '@dealstack/shared/lib/generated';

/**
 * Returns the active KYC workflow id from investment details, or undefined
 * when it isn't available yet (parent query still loading, or investor has
 * no active workflow). Controllers must treat undefined as "not ready" and
 * gate their useQueries with `enabled: !!kycWorkflowId` + early-return on
 * mutations.
 */
export const getKycWorkflowId = (
	investmentDetails: GetInvestmentDetailsRes | undefined
): string | undefined => investmentDetails?.activeKycWorkflowId ?? undefined;
